import { useIntl } from '@capsicum/common';
import { CountrySelect, DateInput, Skeleton, SkeletonItem, TextInput } from '@capsicum/common-web';
import styled from 'styled-components';

type IdentityVerificationFormProps = { isFormLoading: boolean };

export const IdentityVerificationForm = ({ isFormLoading }: IdentityVerificationFormProps) => {
	const { $t } = useIntl();

	return (
		<S.Wrapper>
			<S.Section>
				<S.SectionTitle>{$t('kycUserIdentity.personalInformation')}</S.SectionTitle>
				{isFormLoading ? (
					<S.SkeletonWrapper height={56}>
						{Array.from({ length: 5 }, (_, i) => (
							<S.SkeletonInput key={i} />
						))}
					</S.SkeletonWrapper>
				) : (
					<>
						<TextInput
							autoCapitalize="none"
							disabled
							label={$t('global.firstName')}
							name="firstName"
							testID="identity-form-first-name-input"
						/>
						<TextInput
							autoCapitalize="none"
							disabled
							label={$t('global.lastName')}
							name="lastName"
							testID="identity-form-last-name-input"
						/>
						<DateInput
							disabled
							label={$t('global.dateOfBirth')}
							name="dateOfBirth"
							testID="identity-form-date-of-birth-select"
						/>
						<CountrySelect
							disabled
							label={$t('global.nationality')}
							labelProp="name"
							name="nationality"
							searchPlaceholder={$t('requirements.common.form.country.searchPlaceholder')}
							testID="identity-form-nationality-select"
							withoutInitialValue
							withSearch
						/>
						<CountrySelect
							disabled
							label={$t('global.countryOfResidence')}
							labelProp="name"
							name="addressCountry"
							searchPlaceholder={$t('requirements.common.form.country.searchPlaceholder')}
							testID="identity-form-country-of-residence-select"
							withoutInitialValue
							withSearch
						/>
					</>
				)}
			</S.Section>
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		border-radius: ${({ theme }) => theme.sizing.xxsmall};
		background-color: ${({ theme }) => theme.colors.backgrounds.main.container};
	`;

	export const Section = styled.div`
		display: flex;
		flex-direction: column;
		margin-bottom: ${({ theme }) => theme.spacings.medium};
		gap: ${({ theme }) => theme.spacings.xsmall};
	`;

	export const SectionTitle = styled.span`
		${({ theme }) => theme.fonts.headings.title6};
		color: ${({ theme }) => theme.colors.text.main.enabled};
		margin-top: ${({ theme }) => theme.spacings.xxxsmall};
	`;

	export const SkeletonWrapper = styled(Skeleton)`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xsmall};
	`;

	export const SkeletonInput = styled(SkeletonItem)`
		border-radius: ${({ theme }) => theme.sizing.xxsmall};
		margin-bottom: ${({ theme }) => theme.spacings.xxsmall};
	`;
}
